import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class BaseAdministrationHelpersService {
  constructor(private translateService: TranslateService) {}

  setTotalEntitiesNumberLabel(itemsCount: number, entityName: string): string {
    return this.translateService.instant('administration.numberOfElements.entity', {
      itemsCount,
      entityName: this.translateService.instant(entityName),
    });
  }

  setActiveInactiveEntitiesNumberLabel(activeItemsCount: number, inactiveItemsCount: number): string {
    const activeItemsLabel = this.translateService.instant('administration.numberOfElements.active', {
      activeItemsCount,
    });
    const inactiveItemsLabel = this.translateService.instant('administration.numberOfElements.inactive', {
      inactiveItemsCount,
    });

    return activeItemsCount === 0
      ? inactiveItemsLabel
      : inactiveItemsCount === 0
      ? activeItemsLabel
      : `${activeItemsLabel}, ${inactiveItemsLabel}`;
  }
}
